"use client";

import React, { useState } from "react";

import { Button } from "@nextui-org/react";
import { useTranslations } from "next-intl";

import { cn } from "@/utils/cn";

interface SeoTextDisplayProps {
  text: string;
  maxLength?: number; // Maximum characters to show before "Read more"
}

const SeoTextDisplay: React.FC<SeoTextDisplayProps> = ({
  text,
  maxLength = 250, // Default max length
}) => {
  const t = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text || text.trim().length === 0) {
    return null;
  }

  const needsTruncation = text.length > maxLength;
  const displayText =
    isExpanded || !needsTruncation
      ? text
      : `${text.substring(0, maxLength)}...`;

  return (
    <div className="seo-text-display my-6 p-4 border border-gray-200 rounded-lg shadow-sm bg-white">
      <div
        className={cn("prose max-w-none", {
          "overflow-hidden": !isExpanded && needsTruncation,
        })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: displayText }}
      />
      {needsTruncation && (
        <Button
          size="sm"
          variant="light"
          color="primary"
          onPress={() => setIsExpanded(!isExpanded)}
          className="mt-2"
        >
          {isExpanded ? t("showLess") : t("showMore")}
        </Button>
      )}
    </div>
  );
};

export default SeoTextDisplay;
